<template>
    <el-dialog ref="editPsw" title="修改密码" :visible.sync="edit" width="30%" append-center-body>
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
            <el-form-item prop="old_pass" label="登录密码">
                <el-input v-model="form.old_pass" placeholder="请输入当前登录密码" type="password" clearable></el-input>
            </el-form-item>
            <el-form-item prop="new_pass" label="请输入新密码">
                <el-input v-model="form.new_pass" placeholder="请输入新密码" type="password" clearable></el-input>
            </el-form-item>
            <el-form-item prop="againPsw" label="确认密码">
                <el-input v-model="form.againPsw" placeholder="请确认新密码" type="password" clearable></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="edit = false">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>

import {editPswUser} from "@/api/system"

export default {
    name: "editPsw",
    data() {
          const validatePassCheck = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入新密码'));
            } else if (value !== this.form.new_pass) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            open: false,
            edit: false,
            form:{
                old_pass:"",
                new_pass:"",
                againPsw:""
            },
            rules:{
                old_pass: [
                    {
                        required: true,
                        message: "请输入当前登录密码",
                        trigger: "blur"
                    },
                    {
                        min: 6,
                        message: "密码长度不能小于6位数字",
                        trigger: "blur"
                    }
                ],
                new_pass: [
                    {
                        required: true,
                        message: "请输入新密码",
                        trigger: "blur"
                    },
                    {
                        min: 6,
                        message: "密码长度不能小于6位数字",
                        trigger: "blur"
                    }
                ],
                againPsw: [
                    {
                        required: true,
                        validator: validatePassCheck ,
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    methods: {
        show() {
            this.edit = true;
            if(this.open){
                this.$refs.form.resetFields();
            }
            this.open=true;
        },
        async submit(){
            let result=await editPswUser(this.form);
            if(result.status){
                this.$message.success("修改密码成功，请重新登录！");
                setTimeout(() => {
                    this.$store.dispatch("handleLogOut").then(res => {
                        window.location.reload();
                    });
                }, 2000);
            }else{
                this.$message.error(result.info)
            }
        }
    }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/main/components/editPsw/editPsw.vue